import { ProgramSharedStep, ProgramWeekEnum } from 'src/modules/programs/models/programs';
import actionIcon from 'src/public/img/action.png';
import actionOverviewIcon from 'src/public/img/actionOverview-14@3x.png';

import { CPProgramStepProps } from '../../models/cpProgram';
import { CPProgramSharedStep } from '../../weekShared/models/weekShared';
import { ActionAndCommitmentStep } from '../stepComponents/ActionAndCommitmentStep';
import { ChoosingValuedActionStep } from '../stepComponents/ChoosingValuedActionStep';
import { LivingAccordingToYourValuesStep } from '../stepComponents/LivingAccordingToYourValuesStep';
import { WeekThreePlanStep } from '../stepComponents/WeekThreePlanStep';
import { CPProgramWeekThreeStep } from './weekThree';

const steps: (ProgramSharedStep | CPProgramSharedStep | CPProgramWeekThreeStep)[] = [
    ProgramSharedStep.WellbeingCheckInStep,
    ProgramSharedStep.WellbeingScoreStep,
    ProgramSharedStep.FeedbackStep,
    CPProgramWeekThreeStep.LivingAccordingToYourValuesStep,
    CPProgramWeekThreeStep.ActionAndCommitmentStep,
    CPProgramWeekThreeStep.ChoosingValuedActionStep,
    CPProgramWeekThreeStep.WeekThreePlanStep,
    ProgramSharedStep.CongratulationsStep,
];

const stepsProps: CPProgramStepProps[] = [
    {
        id: CPProgramWeekThreeStep.LivingAccordingToYourValuesStep,
        component: LivingAccordingToYourValuesStep,
        tooltip: 'Living according to your values',
        noButtons: true,
        grayBackground: true,
    },
    {
        id: CPProgramWeekThreeStep.ActionAndCommitmentStep,
        component: ActionAndCommitmentStep,
        tooltip: 'Action and commitment',
        flexGrow: false,
    },
    {
        id: CPProgramWeekThreeStep.ChoosingValuedActionStep,
        component: ChoosingValuedActionStep,
        tooltip: 'Choosing a valued action',
        noButtons: true,
    },
    {
        id: CPProgramWeekThreeStep.WeekThreePlanStep,
        component: WeekThreePlanStep,
        tooltip: 'Follow through on your plan',
    },
];

const t = (key: string) => `cp:week-3.data.${key}`;

export const weekThreeData = {
    id: ProgramWeekEnum.WeekThree,
    title: t('title'),
    definition: t('definition'),
    congratulationsSneakPeek: t('congratulationsSneakPeek'),
    description: t('description'),
    endOfCourseDefinition: t('endOfCourseDefinition'),
    feedbackPlaceholder: t('feedbackPlaceholder'),
    iconUrl: actionIcon,
    congratulationsIconUrl: actionOverviewIcon,
    weekNumber: 2,
    readableWeekNumber: 3,
    greetingModalContent: t('greetingModalContent'),
    steps,
    stepsProps,
};

export const activitySelectionDomains = [
    {
        id: 0,
        title: '',
        activities: [],
    },
];

export const initialActivitiesDomains = activitySelectionDomains;
